// IMAGE URLS

// TODO webpack 2.0 to enable import of server/env.js
const imageHost = process.env.IMAGE_HOST || `/assets`;
const oneCommerceImageHost =
  process.env.ONECOMMERCE_IMAGE_HOST ||
  'https://onecommerce-dev.s3.amazonaws.com';

const seoImages = `${imageHost}/seo-images/`;
const urlAboutUs = `${imageHost}/page-about-us/`;
const urlAboutUsTeam = `${urlAboutUs}team/`;
const urlBanner = `${imageHost}/banner/`;
const urlCatalog = `${imageHost}/catalog/`;
const urlCauseBadge = `${imageHost}/cause/badge/`;
const urlCauseHero = `${imageHost}/cause/hero/`;
const urlFeedback = `${imageHost}/feedback/`;
const urlTree = `${imageHost}/page-tree/`;
const urlHelp = `${imageHost}/help/`;
const urlIconSocial = `${imageHost}/icon/social/`;
const urlIcons = `${imageHost}/icon/`;
const urlJs = `${imageHost}/js/`;
const urlLogo = `${imageHost}/logo/`;
const urlRecap2017 = `${imageHost}/page-recap-2017/`;
const urlSvg = `${imageHost}/svg/`;
const urlProfile = `${oneCommerceImageHost}/profile/`;
const urlDefaultProfile = `${imageHost}/profile/`;
const urlTheGrapefulClub = `${imageHost}/page-the-grapeful-club/`;
const urlWineclub = `${imageHost}/wineclub/`;
const urlShimmer2018 = `${imageHost}/page-shimmer-2018/`;

const common = `${imageHost}/_common/`;
const urlCommonImg = `${common}img/`;

const urlAuthentication = `${imageHost}/authentication`;
const homepage = `${imageHost}/page-home/`;
const urlHomepageBackground = `${homepage}background/`;
const urlHomepageCategory = `${homepage}category/`;
const urlHomepagePress = `${homepage}press/`;
const urlHomepageSocial = `${homepage}social/`;
const urlImpact = `${imageHost}/page-impact/`;
const urlImpactPartners = `${imageHost}/page-impact/partners/`;
const urlVineyard = `${imageHost}/page-vineyard/`;
const urlWeddings = `${imageHost}/page-weddings/`;
const urlWinemaking = `${imageHost}/page-winemaking/`;
const urlVisit = `${imageHost}/page-visit/`;

const shop = `${imageHost}/shop/`;
const urlShopCategory = `${shop}category/`;
const urlShopIcon = `${shop}icon/`;
const urlShopLanding = `${shop}landing/`;
const urlShopPairing = `${shop}pairing/`;
const urlShopProduct = `${shop}product/`;
const urlSquareShopProduct = `${shop}square-product/`;
const urlSipsterhood = `${imageHost}/page-sipsterhood/`;

const corporate = `${imageHost}/page-corporate/`;
const urlEventPage = `${imageHost}/page-event/`;
const urlCorporatePageBackground = `${corporate}background/`;
const urlCorporatePageBranding = `${corporate}branding/`;
const urlCorporatePageBuildYourOwnGift = `${corporate}build-your-own-gift/`;
const urlCorporatePageCustomShimmer = `${corporate}custom-shimmer/`;
const urlCorporatePageBulkDiscounts = `${corporate}bulk-discounts/`;
const urlCorporatePageCommon = `${corporate}common/`;
const urlCorporatePagePartners = `${corporate}partners/`;

const orders = `${imageHost}/page-orders/`;
const urlReceiptPage = `${orders}receipt/`;

const urlBecomeACeo = `${imageHost}/page-become-a-ceo/`;
const urlCeEnrollment = `${imageHost}/page-become-a-ceo/ce-enrollment`;
const urlHostATasting = `${imageHost}/page-host-a-tasting/`;
const urlSubscription = `${imageHost}/subscription/`;

module.exports = {
  seoImages,
  shop,
  urlAboutUs,
  urlAboutUsTeam,
  urlBanner,
  urlBecomeACeo,
  urlCatalog,
  urlCauseBadge,
  urlCauseHero,
  urlCommonImg,
  urlCeEnrollment,
  urlCorporatePageBackground,
  urlCorporatePageBranding,
  urlCorporatePageBuildYourOwnGift,
  urlCorporatePageCustomShimmer,
  urlCorporatePageBulkDiscounts,
  urlCorporatePageCommon,
  urlCorporatePagePartners,
  urlFeedback,
  urlHelp,
  urlEventPage,
  urlAuthentication,
  urlHomepageBackground,
  urlHomepageCategory,
  urlHomepagePress,
  urlHomepageSocial,
  urlHostATasting,
  urlIconSocial,
  urlIcons,
  urlImpact,
  urlImpactPartners,
  urlJs,
  urlLogo,
  urlProfile,
  urlDefaultProfile,
  urlRecap2017,
  urlReceiptPage,
  urlShimmer2018,
  urlShopCategory,
  urlShopIcon,
  urlShopLanding,
  urlShopPairing,
  urlShopProduct,
  urlSquareShopProduct,
  urlSipsterhood,
  urlSubscription,
  urlSvg,
  urlTheGrapefulClub,
  urlTree,
  urlVineyard,
  urlWeddings,
  urlWinemaking,
  urlVisit,
  urlWineclub,
  imageHost,
  oneCommerceImageHost,
};
